__turbopack_context__.v({
  "bredCrumbs_block": "page-module-scss-module__RGUKVW__bredCrumbs_block",
  "landscapingPageButtonWrapper": "page-module-scss-module__RGUKVW__landscapingPageButtonWrapper",
  "landscpSvg": "page-module-scss-module__RGUKVW__landscpSvg",
  "landscpSvgFirst": "page-module-scss-module__RGUKVW__landscpSvgFirst",
  "landscpSvgThree": "page-module-scss-module__RGUKVW__landscpSvgThree",
  "landscpSvgTwo": "page-module-scss-module__RGUKVW__landscpSvgTwo",
  "parallaxContainer": "page-module-scss-module__RGUKVW__parallaxContainer",
  "svgClass": "page-module-scss-module__RGUKVW__svgClass",
  "svgClassFirst": "page-module-scss-module__RGUKVW__svgClassFirst",
  "svgClassThee": "page-module-scss-module__RGUKVW__svgClassThee",
  "svgClassTwo": "page-module-scss-module__RGUKVW__svgClassTwo",
});
